<template>
    <div class="mt-2" :style="`margin-left: ${campaign.margin}rem`">
        <v-btn v-if="campaign.selectable" icon :ripple="{ class: 'primary--text' }" @click="selectCampaign(campaign.value)">
            <v-icon v-if="campaign.value !== selectedCampaign" color="primary">radio_button_unchecked</v-icon>
            <v-icon v-else color="primary">radio_button_checked</v-icon>
        </v-btn>
        <v-btn icon v-else></v-btn>
        <span class="campaign-title" :class="{active: campaign.value === selectedCampaign}" @click="selectCampaign(campaign.value)">{{ campaign.title }}
            <i class="material-icons">{{ campaign.icon }}</i>
        </span>
        <campaign-element
                v-if="campaign.subbullets"
                v-for="(child, index) in campaign.subbullets"
                :key="index"
                :campaign="child"
                :selectedCampaign="selectedCampaign"
                @selectCampaign="selectCampaign"
        />
    </div>
</template>
<style>
    .campaign-title {
        display: inline-flex;
        align-items: center;
        padding: .5rem 1rem;
        border: 2px solid #1976d2;
        width: 240px;
        height: 48px;
        border-radius: 10px;
        cursor: pointer;
        transition: .2s ease-in-out;
        font-size: 1.1rem;
    }
    .campaign-title i{
        color: #1976d2;
        margin-left: .5rem;
    }
    .campaign-title.active {
        background-color: #1976d2;
        color: #fff;
    }
    .campaign-title.active i {
        color: #fff;
    }
</style>
<script>
  import CampaignElement from './CampaignElement.vue'
  export default {
    name: 'campaign-element',
    components: {
      CampaignElement
    },
    data () {
      return {}
    },
    props: ['campaign', 'selectedCampaign'],
    methods: {
      selectCampaign (campaign) {
        this.$emit('selectCampaign', campaign)
      }
    }
  }
</script>
